import React,{ useState } from 'react'
import { Link } from 'gatsby';

export default function LeftMenu({ route }){
  const [ mobileMenuOpening, setMobileMenuOpening ] = useState(false);
  const [ openMobileMenu, setOpenMobileMenu] = useState(false);

  const openMenu = () => {
    if(mobileMenuOpening)
      return;
    setOpenMobileMenu(true);
    setTimeout(() => {
      setMobileMenuOpening(true);
    },50);
  }
  const closeMenu = () => {
    if(!mobileMenuOpening)
      return;
    setOpenMobileMenu(false);
    setMobileMenuOpening(false);
  }

  return(
    <div className={"leftMenu" + (mobileMenuOpening ? " active" : "") }>
      <div className="title">
        <a href="#" className="mobileToggle" onClick={(e) => {
          e.preventDefault();
          if(openMobileMenu)
            closeMenu();
          else   
            openMenu();
        }}>
          <span>Toggle Menu</span>
        </a>
        <a href="https://sites.google.com/view/cosmosbravesbar/首頁">TRPG Braves' Bar</a>
      </div>
      <div className="navList">
        <div className="nav">
          <a href="https://sites.google.com/view/cosmosbravesbar/首頁">首頁</a>
        </div>
        <div className="nav">
          <a href="https://sites.google.com/view/cosmosbravesbar/使用方式">使用方式</a>
        </div>
        <div className="nav">
          <a href="https://sites.google.com/view/cosmosbravesbar/使用狀況">使用狀況</a>
        </div>
        <div className={`nav ${route === "/" ? 'active' : ''}`}>
          <Link to="/">團錄閱覽</Link>
          {/*<a href="https://sites.google.com/view/cosmosbravesbar/團錄閱覽">團錄閱覽</a>*/}
        </div>
        <div className="nav">
          <a href="https://sites.google.com/view/cosmosbravesbar/募集布告欄">募集布告欄</a>
        </div>
        <div className="nav">
          <a href="https://sites.google.com/view/cosmosbravesbar/回報問題">回報問題</a>
        </div>
        <div className={`nav ${route === "/publication/" ? 'active' : ''}`}>
          {/*<Link to="/publication">場次商品一覽</Link>*/}
          <a href="https://sites.google.com/view/cosmosbravesbar/場次商品一覽">場次商品一覽</a>
        </div>
        {/*<div className={`nav ${route === "/scenario/" ? 'active' : ''}`}>
          <Link to="/scenario">劇本一覽</Link>
          <a href="https://sites.google.com/view/cosmosbravesbar/場次商品一覽">場次商品一覽</a>
        </div>*/}
      </div>
      {openMobileMenu &&
          <div className={"menuOverlay" + (mobileMenuOpening ? " opening" : "")} onClick={(e) => {
            e.preventDefault();
            closeMenu();
          }}></div>
      }
    </div>
  )
}